import { routes as main } from '@/modules/core/main'
import { routes as auth } from '@/modules/core/auth'
import { routes as tracker } from '@/modules/widgets/tracker'
import { routes as counter } from '@/modules/widgets/counter'
import { routes as memory } from '@/modules/widgets/memory'
export default [...main, ...auth, ...tracker, ...counter, ...memory]
